import LegalTerms from './LegalTerms';

export default LegalTerms;